import { isCVReview, SCHEMAS } from './product.model';
import {
	CVReview_1004,
	CVReview_1073,
	CVReview_1075,
	CVReview_2055,
	InspectionReport,
	CVReviewAltVal
} from './intelligence/index';
import { GENERAL_SCHEMA } from './schema-nav';

export class NavUtils {
	/**
	 * build navigation depends on schema
	 * @param schema
	 * @param isCMPForm
	 */
	static getSchemaNav(schema: string, isCMPForm: boolean = false): any {
		let schemaName: any = false;
		let items: any = [];

		switch (schema) {
			case SCHEMAS.CVReview_1004:
				schemaName = SCHEMAS.CVReview_1004;
				items = CVReview_1004;
				break;

			case SCHEMAS.CVReview_1073:
				schemaName = SCHEMAS.CVReview_1073;
				items = CVReview_1073;
				break;

			case SCHEMAS.CVReview_1075:
				schemaName = SCHEMAS.CVReview_1075;
				items = CVReview_1075;
				break;

			case SCHEMAS.CVReview_2055:
				schemaName = SCHEMAS.CVReview_2055;
				items = CVReview_2055;
				break;

			case SCHEMAS.InspectionReport:
				schemaName = SCHEMAS.InspectionReport;
				items = InspectionReport;
				break;
		}
		// Or if is CMP Form true, render like this as well
		if (isCMPForm) {
			items = CVReviewAltVal;
			// All AltVal products start with CVReview plus isCMPForm
			if (!schemaName && isCVReview(schema)) {
				schemaName = SCHEMAS.CVReviewAltVal
			}
		}

		if (schemaName && items.length > 0) {
			return NavUtils.navBuild(items, schemaName);
		}
	}

	/**
	 * filter the product items and edit nav base on schema
	 * @param items
	 * @param schema
	 */
	static navBuild(items: Array<any>, schema: string): Array<any> {
		const nav = GENERAL_SCHEMA.filter(s => items.includes(s.path));
		return nav.map(n => {
			return { ...n, schema };
		});
	}
}
